<template>
  <div class="main-body margin_bottom" style="color: white">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <button
      class="btn btn-primary btn-sm m-1"
      data-bs-toggle="modal"
      data-bs-target="#AddCategoryModal"
      style="float: right"
    >
      Add Category
    </button>
    <AddCategoryModal></AddCategoryModal>
    
    <div class="container-fluid" style="padding-top:30px">
      <div class="card mt-3 text-white bg-dark">
        <div class="card-body">
          <div class="table-responsive-sm">
            <table class="custom_table">
              <thead>
                <tr>
                  <th>Id</th> 
                  <th>Name</th>
                  <th>Thumb Image</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in getData" :key="index">
                  <td>{{ data.id }}</td>
                  <td>{{ data.name }}</td>
                  <td><img :src="data.thumb_path" height="50px;" width="60px;"/></td>
                  <td>
                    <h6>
                      <span
                        v-on:click="categoryCredential(data.id, data.name, data.thumb_path)"
                        class="badge bg-success"
                        style="cursor: pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#UpdateCategoryModal"
                        >Update</span
                      >&ensp;
                      <span class="badge bg-danger" style="cursor: pointer"
                        >Delete</span
                      >
                    </h6>
                  </td>
                  <UpdateCategoryModal
                    :c_id="categoryId"
                    :c_name="categoryName"
                    :c_image="categoryImage"
                  ></UpdateCategoryModal>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import AddCategoryModal from "./AddCategoryModal";
import UpdateCategoryModal from "./UpdateCategoryModal";
export default {
  components: { Loading, AddCategoryModal, UpdateCategoryModal },
  data() {
    return {
      categoryId: "",
      categoryName: "",
      categoryImage:"",
      getData: [],
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    async getCategoryData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/categories",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.getData = res.data;
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    categoryCredential(id, name, image) {
      this.categoryId = id;
      this.categoryName = name;
      this.categoryImage = image;
    },
  },
  mounted() {
    this.getCategoryData();
  },
};
</script>
<style scoped>
@import "../../assets/css/audioBook.scss";
@import "../../assets/css/audioNav.scss";
</style>